export const fetchLoyaltyDetails = () => {
  const email = document.querySelector('[data-customer]')?.dataset.customer;
  if (email) {
    const guid = 'D06-6dZPUqA9vgYpJNuEhg',
      apiKey = 'T3wVnRUloj0KZNBMW3TqSQtt';
    const url = `https://loyalty.yotpo.com/api/v2/customers?customer_email=${email}&country_iso_code=null&with_referral_code=false&with_history=true&guid=${guid}&api_key=${apiKey}`;
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
      },
    };
    fetch(url, options)
      .then((res) => res.json())
      .then((json) => {
        window.Brooklinen.loyalty = window.Brooklinen?.loyalty || {};
        window.Brooklinen.loyalty.points_balance = json.points_balance;
        window.Brooklinen.loyalty.vip_tier_name = json.vip_tier_name;
      })
      .catch((err) => {
        console.error(err);
      });
  }
};
